import React from "react";
import { t } from "@auto/services";

export const ApplicationHeader = () => (
  <div style={{
    width: "100%",
    textAlign: "center",
    fontSize: "17px",
    fontWeight: 700,
    letterSpacing: "0.01em",
  }}>
    {t("stats.title")}
  </div>
);

export default ApplicationHeader;
